module.exports = __webpack_public_path__ + "static/media/tire-pressure-warning.21fedf67.svg";